var ApprovalStatus = /* @__PURE__ */ ((ApprovalStatus2) => {
  ApprovalStatus2["APPROVED"] = "approved";
  ApprovalStatus2["REJECTED"] = "rejected";
  ApprovalStatus2["NEW"] = "new";
  ApprovalStatus2["REQUEST_APPROVAL"] = "request_approval";
  return ApprovalStatus2;
})(ApprovalStatus || {});

export { ApprovalStatus };
